import 'jquery';
import 'Lib/font-load/font-load';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Lib/touch-retina-to-html-tag/touch-retina-to-html-tag';
import 'Bem/site/checkbox-accept/checkbox-accept';
import 'Bem/site/ajax-form/ajax-form';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/footer/footer';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'imports-loader?wrapper=window!jquery-throttle-debounce'; // eslint-disable-line import/no-extraneous-dependencies, import/no-webpack-loader-syntax
import { onScreen } from 'Lib/on-screen/on-screen';

onScreen($('.certificate-publication-book__section'), ($el) => {
    $el.addClass('certificate-publication-book__section_visible');
}, 200, 200, 1.6);

svgSpriteLoader('/landing/certificate-publication-book/svg/sprite.svg?v=20181207');
